import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import allReviewsReducer, * as reviewsActions from 'redux/modules/allReviews';
import { connect } from 'react-redux';
import { provideHooks } from 'redial';
import Loading from 'react-loading-animation';
import UserReviewCard from 'components/UserReviewCard/Loadable';
import InfiniteScroll from 'react-infinite-scroll-component';
import { withTranslation } from 'react-i18next';
import replaceS3WithCDN from 'utils/replaceS3WithCDN';
import moment from 'moment-timezone';

import config from '../../config';

@provideHooks({
  inject: ({ store }) => store.inject({ allReviews: allReviewsReducer }),
})
@connect(
  state => ({
    reviews: state.allReviews && state.allReviews.reviews,
    reviewsLoadded: state.allReviews && state.allReviews.loaded,
    reviewsLoading: state.allReviews && state.allReviews.loading,
    loadingMore: state.allReviews && state.allReviews.loadingMore,
    noMoreToLoad: state.allReviews && state.allReviews.noMoreToLoad
  }),
  { ...reviewsActions }
)
@withTranslation(['common', 'meta'])
class Reviews extends Component {
  static propTypes = {
    reviews: PropTypes.arrayOf(PropTypes.any),
    reviewsLoadded: PropTypes.bool,
    reviewsLoading: PropTypes.bool,
    noMoreToLoad: PropTypes.bool.isRequired,
    loadReviews: PropTypes.func.isRequired,
    loadMoreReviews: PropTypes.func.isRequired,
    loadingMore: PropTypes.bool.isRequired,
    t: PropTypes.func.isRequired
  };

  static defaultProps = {
    reviews: [],
    reviewsLoadded: false,
    reviewsLoading: false
  };

  componentDidMount() {
    const { reviewsLoadded, loadReviews } = this.props;

    if (!reviewsLoadded) {
      loadReviews();
    }
  }

  getLastIndex() {
    const { reviews } = this.props;

    if (reviews && reviews.length) {
      return reviews[reviews.length - 1].id;
    }

    return 0;
  }

  render() {
    const styles = require('./Reviews.scss');
    const {
      reviews,
      reviewsLoadded,
      reviewsLoading,
      loadMoreReviews,
      noMoreToLoad,
      loadingMore,
      t
    } = this.props;
    let lastIndex = 0;

    if (reviews) {
      lastIndex = this.getLastIndex();
    }

    return (
      <div data-cy="cy-reviews-container">
        {/* eslint-disable max-len */}
        <Helmet
          title={t('meta:META.REVIEWS.TITLE')}
          meta={[
            {
              name: 'description',
              content: t('meta:META.REVIEWS.TITLE')
            },
            {
              property: 'og:title',
              content: t('meta:META.REVIEWS.TITLE')
            },
            {
              property: 'og:description',
              content: t('meta:META.REVIEWS.TITLE')
            },
            {
              property: 'og:url',
              content: `${config.app.url}/drivers/reviews`
            },
            { id: 'english-canonical-url', content: '' }
          ]}
        />
        {/* eslint-enable */}

        {/* eslint-disable max-len */}
        <div
          className={styles.masthead}
          style={{
            background:
              'url("https://images.unsplash.com/photo-1465385621528-53653983a38f?auto=format&fit=crop&w=2553&q=60&ixid=dW5zcGxhc2guY29tOzs7Ozs%3Dmisc/athena-lam-100455-reduce.jpg")  center center / cover'
          }}
        >
          {/* eslint-enable */}
          <div className={styles.jumboHead}>
            <h1 className={styles.headline}>{t('REVIEWS.BANNER_SUBTITLE')}</h1>
          </div>
        </div>
        <div>
          <div className={`${styles.content} container`}>
            <div className={styles.contentSection}>
              <p>{t('REVIEWS.PARAGRAPH_1')}</p>
              <p>{t('REVIEWS.PARAGRAPH_2')}</p>
              <p>{t('REVIEWS.PARAGRAPH_3')}</p>
            </div>

            <div className={styles.reviewHeaderContainer}>
              <h3 className={styles.subtitle}>{t('REVIEWS.SEE_OUR')}</h3>
              <h2 className={styles.title}>{t('REVIEWS.REVIEWS')}</h2>
              <span className={styles.shortDivider} />
            </div>
          </div>
          {
            !reviewsLoadded || reviewsLoading
              ? <Loading />
              : (
                <InfiniteScroll
                  scrollThreshold={0.5}
                  next={() => {
                    loadMoreReviews({ index: lastIndex });
                  }}
                  hasMore={!noMoreToLoad}
                >
                  <div className={`${styles.reviewsContainer} container`}>
                    {
                      reviews.map((review, index) => {
                        const {
                          guest,
                          created_at: _createAt,
                          overall_rating: overallRating,
                          content: _review,
                        } = review;
                        const {
                          first_name: name,
                          profile_photo_thumbnail_url: _photo,
                        } = guest;
                        const photo = replaceS3WithCDN(_photo);
                        const rating = parseFloat(overallRating);
                        const createAt = moment(_createAt).format('MMMM YYYY');
                        const data = {
                          user: {
                            name,
                            photo,
                          },
                          createAt,
                          review: _review,
                          rating,
                        };

                        return (
                          <div
                            data-cy="cy-review-card"
                            className={styles.cardContainer}
                            key={`review=${review.id}-${index}`}
                          >
                            <UserReviewCard {...data} />
                          </div>
                        );
                      })
                    }
                  </div>
                </InfiniteScroll>
              )
          }
          <div data-cy="cy-bottom-boundary" />
          { loadingMore ? <div className="loader"><Loading /></div> : null }
          {
            noMoreToLoad
              ? (
                <h3 className={styles.noMoreToLoad}>
                  {`${t('REVIEWS.ALL_LOADED')} `}
                  <span role="img" aria-label="all loaded">
                    🎉
                  </span>
                </h3>
              )
              : null
          }
        </div>
      </div>
    );
  }
}

export default Reviews;
